import { render } from "./BlenderLink7.vue?vue&type=template&id=f9039b06"
import script from "./BlenderLink7.vue?vue&type=script&lang=js"
export * from "./BlenderLink7.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__